export const AUTH_ENDPOINTS = {
  SIGNIN: "/v4/auth/signin",
  SIGNOUT: "/v4/auth/signout",
  ME: "/v4/users/me",
  OAUTH_SIGNIN: "/auth/idfs",
};

export const ssoHandleTokenPath = "/authHandleToken";
